import { render } from "./search_bar.vue?vue&type=template&id=2eae7674"
import script from "./search_bar.js?vue&type=script&lang=js"
export * from "./search_bar.js?vue&type=script&lang=js"

import "./search_bar.vue?vue&type=style&index=0&id=2eae7674&lang=scss"

import exportComponent from "/Users/lainsoykaf/repos/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__